export default __webpack_public_path__ + "static/media/firebase.ff491d66.svg";